import { createSelector } from 'reselect'

/**
 * Select the nav state slice
 * @param {object} state - Redux state
 * @returns {object} Nav state
 */
export const selectNav = (state) => state.nav

/**
 * Select the redirect path
 * @param {object} state - Redux state
 * @returns {string|null} Redirect path
 */
export const selectRedirect = createSelector(
  selectNav,
  (nav) => nav.redirect
)
